export default {
  'global.button.viewAll': 'View All',
  'global.button.viewAll1': 'View All',
  'global.button.cancel': 'Cancel',
  'global.button.close': 'Close',
  'global.button.add1': 'Add',
  'global.button.add': 'Add',
  'global.button.save': 'Save',
  'global.button.confirm': 'Confirm',
  'global.button.delete': 'Delete',
  'global.button.edit': 'Edit',
  'global.button.test': 'Test',
  'global.button.publish': 'Publish',
  'global.button.continues': 'Continue',
  'global.button.reject': 'Reject',
  'global.button.detail': 'Details',
  'global.button.delegatedTask': 'Delegated Tasks',
  'global.button.approved': 'Approve',
  'global.button.complete': 'Complete',
  'global.button.execution': 'Executed',
  'global.button.signature': 'Sign',
  'global.button.send': 'Send',
  'global.button.toLogin': 'Go to Login',
  'global.button.toHome': 'Go to Home',
  'global.button.enter': 'Enter',
  'global.button.ms365': 'Microsoft 365',
  'global.button.rememberMe': 'Remember Me',
  'global.button.copy': 'Copy',
  'global.button.reset.password': 'Reset Password',
  'global.button.sendCode': 'Send Code',
  'global.button.addForm': 'Create Form',
  'global.button.export': 'Export',
  'global.button.import': 'Import',
  'global.button.createRequest': 'Create Request',
  'global.button.viewDetails': 'View Details',
  'global.button.cancelRequest': 'Cancel Request',
  'global.button.completeRequestInformation': 'Complete Request Information',
  'global.button.approveRequest': 'Approve Request',
  'global.button.executeTask': 'Execute Task',
  'global.button.signDocument': 'Sign Document',
  'global.button.reassignTask': 'Reassign Task',
  'global.button.massRequestApprove': 'Approve Requests',
  'global.button.massRequestReject': 'Reject Requests',
  'global.button.initApplication': 'Initiate Request',
  'global.button.erase': 'Clear',
  'global.button.undo': 'Undo',
  'global.button.redo': 'Redo',
  'global.text.radius.brush': 'Brush Radius',
  'global.button.approve': 'Approve',
  'global.button.toFilter': 'Filter',
  'global.button.apply': 'Apply',
  'global.button.resetFilters': 'Reset Filters',
  'global.button.no': 'No',
  'global.button.yes': 'Yes',
  'global.button.signIn': 'Sign In',
  'global.button.cleanup': 'Cleanup',
  'global.button.download': 'Download',
  'global.button.print': 'Print',
  'global.button.next': 'Next',
  'global.button.previous': 'Previous',
  'global.button.google': 'Google',
  'global.button.backInAutomy': 'Enter',
  'global.button.saveAndComplete': 'Complete',
  'global.button.extraFields': 'Extra Fields',
  'global.button.sendAccountConfirmationEmail': 'Account Confirmation',
  'global.button.confirmAccount': 'Confirm Account',
  'global.button.sendPasswordRecoveryEmail': 'Recover Password',
  'global.button.resetPassword': 'Reset Password',
  'global.button.unlockAccount': 'Unlock Account',
  'global.button.generate': 'Generate',
  'global.button.retry': 'Retry',
  'global.button.import': 'Import',
  'global.button.export': 'Export',
  'global.button.purge': 'Purge Data',
  'global.restore.confirmQuestion': 'Do you want to restore it?',
  'global.restore.restoreButton': 'Restore',
  // Canvas actions
  'action.config.beautify': 'Beautify',
  'action.canvas.fit': 'Fit',
  'action.canvas.center': 'Center',
  'action.canvas.reset': 'Reset',
  'action.canvas.zoomIn': 'Zoom In',
  'action.canvas.zoomOut': 'Zoom Out',
  'action.canvas.addNote': 'Add Note',
  'action.canvas.fullscreen': 'Fullscreen',
  'action.canvas.exitFullscreen': 'Exit fullscreen',
  'action.generate.ai.coming.soon': 'Generate AI (coming soon)',
  'global.button.addGroup': 'Add Group',
  'global.button.removeCondition': 'Remove Condition',
  'global.button.loadExcel': 'Load Excel',
  'global.button.company': 'Change Company',
  'global.button.environment': 'Change Environment',
  'global.button.moreDetail': 'More Details',
  'global.button.lessDetail': 'Less Details',
  'global.text.contentTooLarge': 'The content is too large to display. Please download it to view.',
  'global.button.pin': 'Send Approval PIN',
  'global.button.myDay.add': 'Add to My Day',
  'global.button.mark.important': 'Mark as Important',
  'global.button.mark.completed': 'Mark as Completed',
  'global.button.info': 'Information',
  'global.button.move': 'Move to...',
  'global.button.delete': 'Delete',
  'global.button.create.list': 'Create List',
  'global.button.accountConfirm': 'Confirm Account',
  'global.button.create': 'Create',
  'global.button.create.task': 'Create Task',
  'global.button.accountConfirm': 'Confirm Account',
  'global.button.details': 'Details',
  'global.button.editGridMode': 'Edit',
  'global.button.exitGridMode': 'Exit Edit',
  'global.button.data': 'Data',

  'global.status.sent': 'Sent',
  'global.status.sent1': 'Sent',
  'global.status.received': 'Received',
  'global.status.received1': 'Received',
  'global.status.pending': 'Pending',
  'global.status.pending1': 'Pending',
  'global.status.running': 'Running',
  'global.status.canceled': 'Canceled',
  'global.status.canceled1': 'Canceled',
  'global.status.approved': 'Approved',
  'global.status.approved1': 'Approved',
  'global.status.rejected': 'Rejected',
  'global.status.rejected1': 'Rejected',
  'global.status.voided': 'Voided',
  'global.status.voided1': 'Voided',
  'global.status.required': 'Required',
  'global.status.noRequired': 'Not Required',
  'global.status.execution': 'Execution',
  'global.status.error': 'Error',
  'global.status.processing': 'Processing',
  'global.status.processed': 'Processed',
  'global.status.processingTaskItems': 'Processing Task Items',

  'global.text.agent': 'AI Agent',
  'global.copyright': 'All rights reserved',
  'global.text.copyright': 'Copyright',
  'global.text.add': 'Add',
  'global.text.remove': 'Remove',
  'global.text.update': 'Update',
  'global.text.activate': 'Activate',
  'global.text.detail': 'Detail',
  'global.text.detail1': 'Details',
  'global.text.summary': 'Summary',
  'global.text.events': 'Events',
  'global.text.eventHistory': 'Event history',
  'global.text.application': 'Request',
  'global.text.edit': 'Edit',
  'global.text.cancel': 'Cancel',
  'global.text.processes': 'Processes',
  'global.text.groups': 'Groups',
  'global.text.items': 'Items',
  'global.text.entities': 'Entities',
  'global.text.premiumEntities': 'Premium Entities',
  'global.text.premium': 'Premium',
  'global.text.basic': 'Basic',
  'global.text.showList': 'Show List',
  'global.text.viewReport': 'View Report',
  'global.text.favorites': 'Favorites',
  'global.text.list': 'List',
  'global.text.lists': 'Lists',
  'global.text.report': 'Report',
  'global.text.reports': 'Reports',
  'global.text.adminReports': 'System',
  'global.text.group': 'Group',
  'global.text.all': 'All',
  'global.text.all1': 'All',
  'global.text.advancedFilter': 'Advanced Filter',
  'global.text.hideFilter': 'Hide Filter',
  'global.text.search': 'Search',
  'global.text.filters': 'Filters',
  'global.text.date': 'Date',
  'global.text.createdDate': 'Created Date',
  'global.smsDeliveryProvider.twilio': 'Twilio',
  'global.smsDeliveryProvider.sendblue': 'Sendblue',
  'global.text.updatedDate': 'Updated Date',
  'global.text.isPublic': 'Is Public?',
  'global.text.user': 'User',
  'global.text.system': 'System',
  'global.text.users': 'Users',
  'global.text.url': 'URL',
  'global.text.headers': 'Headers',
  'global.text.key': 'Key',
  'global.text.value': 'Value',
  'global.text.host': 'Host',
  'global.text.position': 'Position',
  'global.text.port': 'Port',
  'global.text.userGroup': 'User Group',
  'global.text.config': 'Configure',
  'global.text.processConfig': 'Configure',
  'global.text.restricted': 'Restricted',
  'global.text.public': 'Public',
  'global.text.permissions': 'Permissions',
  'global.text.menu': 'Menu',
  'global.text.validated': 'Validated',
  'global.text.notValidated': 'Not Validated',
  'global.text.published': 'Published',
  'global.text.draft': 'Draft',
  'global.text.server': 'Server',
  'global.text.byPosition': 'By Position',
  'global.text.byUser': 'By User',
  'global.text.byGroup': 'By Group',
  'global.text.byGroups': 'By Groups',
  'global.text.userExit': 'User Exists',
  'global.text.positionExit': 'Position Exists',
  'global.text.userGroupExit': 'User Group Exists',
  'global.text.token': 'Token',
  'global.text.apiKeySecret': 'API Key Secret',
  'global.text.fromPhoneNumber': 'From phone number',
  'global.text.process': 'Process',
  'global.text.web': 'Web',
  'global.text.mobile': 'Mobile',
  'global.text.webMobile': 'Web & Mobile',
  'global.text.action': 'Action',
  'global.text.showBy': 'Show By',
  'global.text.operation': 'Operation',
  'global.text.observation': 'Observation',
  'global.text.administrator': 'Administrator',
  'global.text.superAdministrator': 'Super Administrator',
  'global.text.copying': 'Copying',
  'global.text.network.title': 'Network Exception',
  'global.text.network.info': `The connection to the server could not be established. Please check your internet connection and try again.`,
  'global.text.timeout.title': 'Request Timeout',
  'global.text.timeout.info': 'The request is taking too long. Please try again.',
  'global.text.cors.title': 'Access Restricted',
  'global.text.cors.info':
    'The operation could not be completed due to a problem communicating with the server. This may be caused by browser security restrictions or network configuration. If the problem persists, please contact support.',
  'global.text.loading': 'loading',
  'global.text.providers': 'Providers',
  'global.text.verifyCode': 'Verification Code',
  'global.text.allowedFileFormats': 'Formats',
  'global.text.startProcess': 'Start',
  'global.text.reassignTask': 'Reassign Task',
  'global.text.site': 'Portals',
  'global.text.app': 'AUTOMY',
  'global.text.start': 'Start',
  'global.text.scheduled': 'Scheduled',
  'global.text.automated': 'Automated',
  'global.text.viewDetail': 'View Detail',
  'global.text.delete': 'Delete',
  'global.text.mode': 'Mode',
  'global.text.table': 'Table',
  'global.text.property': 'Property',
  'global.text.loadingFiles': 'Loading files',
  'global.text.fallback.location': 'Default Location',
  'global.text.fileName': 'File Name',
  'global.text.pageSize': '{num} records',
  'global.text.fields': 'Fields',
  'global.text.appClient': 'App Client',
  'global.text.engineVersion': 'Engine Version',
  'global.text.selectedElements': 'You have {count} {elements} selected',
  'global.text.elementSelected': 'element',
  'global.text.elementsSelected': 'elements',
  'global.text.selectAll': 'Select all',
  'global.text.loading': 'Loading',
  'global.text.isActive': 'Enabled',
  'global.text.favorite': 'Favorite',
  'global.text.diagram': 'Diagram',

  // Connection error messages
  'global.error.connection.noRedirectUrl': 'No redirect URL received from authorization endpoint',
  'global.error.connection.noConnectionId': 'No connection ID returned from creation',
  'global.error.connection.invalidStateFormat': 'Invalid state format - expected GUID',
  'global.error.connection.redirectedToAuthorization': 'Redirected to external authorization',

  // Password validation messages
  'global.error.password.confirmMismatch': 'Confirm password does not match',
  'global.error.password.sameAsCurrent': 'New password must be different from current password',

  // Automy AI Chat errors
  'global.error.automyAI.noResults': 'No Automy AI results found',
  'global.error.automyAI.noThreadId': 'Conversation thread ID not found',
  'global.error.automyAI.openChat': 'Error opening Automy AI conversation',

  'global.text.resource': 'Resource Type',
  'global.text.initBy': 'Started By',
  'global.text.orderBy': 'Order',
  'global.text.entity': 'Entity',
  'global.text.response': 'Response',
  'global.text.operation': 'Operation',
  'global.text.dates': 'Dates',
  'global.text.description': 'Description',
  'global.text.sp_call': 'SP Call',
  'global.text.order': 'Order',
  'global.text.title': 'Title',
  'global.text.name': 'Name',
  'global.text.details': 'Details',
  'global.text.editor': 'Editor',

  'global.text.english': 'English',
  'global.text.spanish': 'Spanish',
  'global.text.language': 'Language',

  'global.text.context.company': 'Companies',
  'global.text.context.environment': 'Environments',
  'global.text.context.user': 'My Profile',
  'global.text.context.site': 'Portals',

  'global.text.plan': 'Plan',
  'global.text.partner': 'Partner',
  'global.text.commercialName': 'Commercial Name',
  'global.text.noIdentity': 'Identity No.',
  'global.text.country': 'Country',
  'global.text.roles': 'Roles',
  'global.text.channel': 'Channel',
  'global.text.distributor': 'Distributor',
  'global.text.reseller': 'Reseller',

  'company.subscription.status.active': 'Active',
  'company.subscription.status.pending-activation': 'Pending activation',
  'company.subscription.status.pending-payment': 'Pending payment',
  'company.subscription.status.past-due': 'Past due',
  'company.subscription.status.suspended': 'Suspended',
  'company.subscription.status.canceled': 'Canceled',

  'company.channel.actor.none': 'No channel',
  'company.channel.actor.automy-internal': 'Automy internal',
  'company.channel.actor.operator': 'Operator',
  'company.channel.actor.distributor': 'Distributor',
  'company.channel.actor.partner': 'Partner',
  'company.channel.actor.reseller': 'Reseller',
  'company.channel.actor.customer': 'Customer',

  'company.role.owner': 'Owner',
  'company.role.admin': 'Admin',
  'company.role.billing-admin': 'Billing Admin',
  'company.role.commercial-admin': 'Commercial Admin',
  'company.role.user-admin': 'User Admin',
  'company.role.support': 'Support',
  'company.role.auditor': 'Auditor',
  'company.role.collaborator': 'Collaborator',
  'company.role.user': 'User',
  'company.role.super-admin': 'Super Admin',

  'company.plan.tag.custom': 'Custom',
  'company.plan.tag.exclusive': 'Exclusive',
  'company.plan.tag.internal': 'Internal',

  'global.text.upload.camera': 'Take a Photo',
  'global.text.upload.image': 'Drag and Drop an Image here or click',
  'global.text.upload.file': 'Drag and Drop a File here or click',
  'global.text.upload.document': 'Drag and Drop a Document here or click',
  'global.text.upload.format.error':
    'Invalid file format. Please upload an Excel file (.xlsx or .xls)',
  'global.text.upload.files': 'Drag and Drop one or multiple files here or click',
  'global.text.validate': 'Validate',

  'global.text.preview': 'Preview',
  'global.text.expand': 'Expand',
  'global.text.editExpanded': 'Edit Expanded',

  'vectorsUploader.subtitle.empty': 'Documents to train the agent',
  'vectorsUploader.subtitle.count': '{count} documents · {size}',
  'vectorsUploader.action.add': 'Add documents',
  'vectorsUploader.action.removeSelected': 'Remove {count} selected',
  'vectorsUploader.search.placeholder': 'Filter documents',
  'vectorsUploader.search.empty': 'No documents match "{q}"',
  'vectorsUploader.selection.selectAll': 'Select all',
  'vectorsUploader.selection.summary': '{count} selected',
  'vectorsUploader.empty.title': 'No training documents yet',
  'vectorsUploader.empty.hint': 'Add documents so the agent can use them as a knowledge base',
  'vectorsUploader.drop.title': 'Drop files here',
  'vectorsUploader.status.indexed': 'Indexed',
  'vectorsUploader.status.uploading': 'Uploading',
  'vectorsUploader.status.uploadingPct': 'Uploading · {pct}%',
  'vectorsUploader.status.error': 'Error',

  'global.created.asc': 'Created Asc',
  'global.created.desc': 'Created Desc',
  'global.text.order.short.asc': 'Created Asc',
  'global.text.order.short.desc': 'Created Desc',

  'global.text.asc': 'Asc',
  'global.text.desc': 'Desc',

  'global.empty': 'No information to show',
  'global.empty.processes': 'You have no processes to manage',
  'global.empty.source': 'You have not entered any information to display yet',
  'global.empty.pendingTasks': 'Congratulations, you have no pending tasks!',

  'global.paged.item5': '5 records',
  'global.paged.items10': '10 records',

  'global.status.active': 'Active',
  'global.status.inactive': 'Inactive',

  'global.tooltip.userGroup': 'User Group',
  'global.tooltip.userEnviroment': 'User Environments',

  'global.enable': 'Enable',
  'global.disable': 'Disable',
  'global.name': 'Name',
  'global.description': 'Description',
  'global.category': 'Category',
  'global.email': 'Email',
  'global.method': 'Method',
  'global.parameters': 'Parameters',
  'global.position': 'Position',
  'global.noData': 'No data',
  'global.authorizationType': 'Authorization Type',

  'global.enabledElement': 'Element Enabled?',
  'global.default': 'Default',
  'global.emailAddress': 'Email Address',
  'global.password': 'Password',
  'global.confirmPassword': 'Confirm Password',
  'global.order': 'Order',
  'global.executionOrder': 'Execution Order',
  'global.isPublic': 'Is Public?',

  'global.uploadFile': 'Drag and Drop a File here or Click',
  'global.enablePin': 'Enable PIN',
  'global.pinCode': 'PIN Code',
  'global.reportType': 'Report Type',
  'global.tags': 'Tags',
  'global.platform': 'Platform',

  'global.user': 'User',
  'global.system': 'System',
  'global.key': 'Key',
  'global.value': 'Value',
  'global.type': 'Type',
  'global.title': 'Title',
  'global.databaseType': 'Database Type',

  'global.role': 'Role',
  'global.show': 'Show',
  'global.created': 'Creation Date',
  'global.updated': 'Update Date',
  'global.userCreator': 'Created By',
  'global.userModifier': 'Updated By',

  'global.of': 'of',
  'global.add': 'Add',

  'process.text.fileName': 'Name',
  'process.text.userCreator': 'Author',
  'process.text.contentType': 'File Type',
  'process.text.options': 'Options',

  'global.text.status': 'Status',
  'global.text.processGroup': 'Process Group',
  'global.text.receivedRequests': 'Received Requests',
  'global.text.myRequests': 'My Requests',
  'global.text.requestOrigin': 'Origin',

  'global.text.queries': 'Queries',
  'global.text.query': 'Query',
  'global.text.database': 'Database',

  'global.text.approved': 'Approved',
  'global.text.rejected': 'Rejected',
  'global.text.signed': 'Signed',
  'global.text.taskExecuted': 'Task Executed',
  'global.text.saved': 'Saved',
  'global.text.completed': 'Completed',
  'global.text.savedAndCompleted': 'Saved and Completed',

  'global.text.processApprovalEvaluation': 'Process Approval Evaluation',
  'global.text.delegation': 'Delegation',
  'global.text.delegationRestored': 'Delegation Restored',
  'global.text.reassignedTask': 'Reassigned Task',
  'global.text.selfAssignedTask': 'Self-assigned Task',

  'global.text.enabled': 'Enabled',
  'global.text.disabled': 'Disabled',
  'global.text.yes': 'Yes',
  'global.text.no': 'No',
  'global.text.administrador': 'Administrator',
  'global.defaults': 'Defaults',
  'global.notDefaults': 'Not Defaults',
  'global.text.criteria': 'Criteria',
  'global.text.note': 'Note',
  'global.text.none': 'None',
  'global.text.minute': 'Minutes',
  'global.text.hour': 'Hours',
  'global.text.day': 'Days',
  'global.text.month': 'Month',
  'global.title.addedUsers': 'Added Users',
  'global.text.form': 'Form',
  'global.text.byAreas': 'By Area',
  'global.text.byArea': 'By Area',
  'global.text.areas': 'Areas',
  'global.text.area': 'Area',
  'global.text.areaExit': 'Area Exists',
  'global.text.itemExists': 'This item already exists in the list',
  'global.text.configuration': 'Configuration',
  'global.text.applicant': 'Applicant',
  'global.text.select': 'Select',

  'global.text.changePassword': 'Change Password',
  'global.text.twoFactor': 'Enable Two-Factor',
  'global.text.modifyView': 'Modify View',
  'global.text.logout': 'Logout',

  'global.text.company': 'Company',
  'global.text.ownerCompany': 'Owner company',
  'global.text.agreement': 'Agreement',
  'global.text.canCreateCustomers': 'Can create customers',
  'global.text.environment': 'Environment',

  'channelEntityStatus.active': 'Active',
  'channelEntityStatus.suspended': 'Suspended',
  'channelEntityStatus.terminated': 'Terminated',

  'channelBillingMode.stripeAutomatic': 'Stripe automatic',
  'channelBillingMode.distributorCredit': 'Distributor credit',
  'channelBillingMode.manualInvoice': 'Manual invoice',

  'channelAgreementType.distributor': 'Distributor',
  'channelAgreementType.partner': 'Partner',
  'channelAgreementType.reseller': 'Reseller',

  'currency.usd': 'USD',
  'global.text.search.company': 'Search company',
  'global.text.search.environment': 'Search environment',
  'global.text.search.site': 'Search portal',

  'global.text.skip.reason': 'Observations',
  'global.text.reject.reason': 'Rejection Reason',
  'global.text.approve.reason': 'Approval Comments',
  'global.text.complete.reason': 'Completion Comments',
  'global.text.cancel.reason': 'Cancellation Reason',
  'global.text.void.reason': 'Void Reason',
  'global.text.delete.reason': 'Confirm Deletion',
  'global.text.delete.description': 'Are you sure you want to delete this item?',
  'global.text.backToAction': 'Back to Action',
  'global.text.goToAction': 'Forward to Action',
  'global.text.actions': 'Actions',
  'global.text.mapSearch': 'Search on map',
  'global.text.maps.geolocate': 'Tap to center the map on your location',
  'global.text.pin.approval.reason': 'Approval PIN',

  'global.text.today': 'Today',
  'global.text.yesterday': 'Yesterday',
  'global.text.last7Days': 'Last 7 Days',
  'global.text.last15Days': 'Last 15 Days',
  'global.text.last30Days': 'Last 30 Days',
  'global.text.currentMonth': 'Current Month',
  'global.text.currentWeek': 'Current Week',
  'global.text.currentYear': 'Current Year',
  'global.text.lastMonth': 'Previous Month',
  'global.text.last3Months': 'Last 3 Months',
  'global.text.last6Months': 'Last 6 Months',
  'global.text.last12Months': 'Last 12 Months',
  'global.text.customRange': 'Custom Range',

  'global.text.ongoingOps': 'Ongoing actions...',
  'global.text.ongoingOps.of': '{counter} of {count}',
  'global.text.configurations': 'Configurations',
  'global.text.void': 'Void',

  'global.error.notAccessibleCamera':
    'Camera is blocked or not accessible.\n Please allow the camera in your browser permissions and try again.',
  'global.switchCamera': 'Switch camera',
  'global.takePhoto': 'Take photo',
  'global.qr.centerCode': 'Center the QR code within the frame',

  'global.message.processInstanceHasChanged':
    'The status of the request has changed; performing update!',
  'global.text.message.outOfBoundLocation': 'The selected location is out of the allowed area',
  'global.text.message.mockLocationProvider':
    'We have detected that you are using a simulated location. This is not allowed in our application, as it affects the accuracy of the services we offer. Please disable location simulation and try again.',
  'global.message.securityCode': 'Approval PIN code sent successfully',

  'global.attachment.type0': 'Unknown',
  'global.attachment.type1': 'Image',
  'global.attachment.type2': 'Video',
  'global.attachment.type3': 'PDF',
  'global.attachment.type4': 'Word Document',
  'global.attachment.type5': 'Spreadsheet',
  'global.attachment.type6': 'Presentation',
  'global.attachment.type7': 'Microsoft Project',
  'global.attachment.type8': 'Text',
  'global.attachment.type9': 'Xml',
  'global.attachment.type10': 'Html',
  'global.attachment.type11': 'Json',
  'global.attachment.type12': 'Zip',
  'global.attachment.type13': 'Audio',
  'global.attachment.type14': 'Rar',
  'global.attachment.type15': 'Font',
  'global.attachment.type16': 'Csv Text',

  'global.observation.type0': 'Observations',
  'global.observation.type1': 'Approval Comments',
  'global.observation.type2': 'Rejection Reason',

  'global.text.notValidFilePath': 'Cannot view file, invalid URL.',
  'global.text.unsupportedFileType': 'Cannot view file, unsupported file type.',
  'global.text.form.placeholder': 'Please fill in all required fields',
  'global.text.importConfirm': 'Do you want to delete existing data?',

  'global.text.error.geolocation.failed': 'Error: Geolocation service failed.',
  'global.text.error.geolocation.support': 'Error: Your browser does not support Geolocation.',
  'global.text.error.geolocation.denied': 'Error: Location access denied.',
  'global.text.error.video.support': 'Video format not supported.',
  'global.text.error.audio.support': 'Audio format not supported.',

  'global.error.title': 'Error',
  'global.error.404.title': 'Page Not Found',
  'global.error.403.subTitle': 'Insufficient permissions. User does not have required permissions.',
  'global.error.404.subTitle': "Looks like you're trying to find your way home",
  'global.error.default': 'The specified application is no longer available',

  'global.planType0': 'Trial',
  'global.planType1': 'Partner',
  'global.planType2': 'Basic',
  'global.planType3': 'Business',
  'global.planType4': 'Enterprise',
  'global.planType5': 'Customized',

  'global.displayText': 'Display Text',
  'global.internalName': 'Internal Name',

  'global.field.text': 'Text',
  'global.field.textMultiple': 'Multiple Text',
  'global.field.int': 'Integer',
  'global.field.int32': 'Integer',
  'global.field.decimal': 'Decimal',
  'global.field.boolean': 'Boolean',
  'global.field.dateTime': 'Date and Time',
  'global.field.date': 'Date',
  'global.field.time': 'Time',
  'global.field.choice': 'Selection',
  'global.field.dataBaseRemoteSearch': 'Database Remote Search',
  'global.field.dataBaseRemoteList': 'Database Remote List',
  'global.field.webServiceRemoteSearch': 'Web Service Remote Search',
  'global.field.webServiceRemoteList': 'Web Service Remote List',
  'global.field.databaseRemoteSearch': 'Database Remote Search',
  'global.field.databaseRemoteList': 'Database Remote List',
  'global.field.webserviceRemoteSearch': 'Web Service Remote Search',
  'global.field.webserviceRemoteList': 'Web Service Remote List',

  'global.field.selectorUser': 'User Selector',
  'global.field.selectorPosition': 'Position Selector',
  'global.field.selectorUserGroup': 'User Group Selector',
  'global.field.table': 'Table',
  'global.field.attachment': 'Attachment',
  'global.field.file': 'File',
  'global.field.autoCalculatedByTableColumn': 'Calculated by Table',
  'global.field.fieldDynamicEntityList': 'Entity List',
  'global.field.calculatedByFormula': 'Calculated by Formula',
  'global.field.image': 'Image',
  'global.field.photo': 'Photo',
  'global.field.signature': 'Signature',
  'global.field.goToAction': 'Go to Action',
  'global.field.slider': 'Slider',
  'global.field.fieldDynamicEntitySearch': 'Entity Search',
  'global.field.selectorArea': 'Area Selector',
  'global.field.radioGroup': 'Radio Group',
  'global.field.checkGroup': 'Check Group',
  'global.field.url': 'URL',
  'global.field.or': 'OR',
  'global.field.and': 'AND',
  'global.field.location': 'Location',
  'global.field.internalEntity': 'Internal Entity',
  'global.field.yesNo': 'Yes/No',
  'global.field.intNumber': 'Integer Number',
  'global.field.decimalNumber': 'Decimal Number',
  'global.field.email': 'Email',
  'global.field.password': 'Password',
  'global.text.dragDrop': 'Drag and drop or click to replace',
  'global.text.deleteData': 'Delete existing data',
  'global.text.selectFile': 'Please select a file',
  'global.button.loadFile': 'Load File',
  'global.text.auditor': 'Auditor',
  'global.text.collaborator': 'Collaborator',
  'global.text.userManager': 'User Manager',
  'global.text.content': 'Content',
  'global.error.import.data': 'Row {rowNumber}: {errorMessage}',
  'global.error.import.multiple':
    'Found {errorCount} errors in the import. Review the details below.',
  'global.error.import.detailed':
    'Found {errorCount} errors in {rowsWithErrors} rows. {originalMessage}',
  'global.text.support': 'Support',
  'global.text.row': 'Row',
  'global.text.column': 'Column',
  'global.text.id': 'ID',
  'global.text.field': 'Field',
  'global.text.error': 'Error',
  'global.text.validate': 'Validate',

  'global.field.ascending': 'Ascending',
  'global.field.descending': 'Descending',
  'global.field.none': 'None',
  'global.field.value': 'Value',
  'global.field.displayText': 'Display Text',
  'global.field.development': 'Development',
  'global.field.testing': 'Testing',
  'global.field.production': 'Production',

  'global.text.columnOrderDirection.ascending': 'Ascending',
  'global.text.columnOrderDirection.descending': 'Descending',
  'global.text.responseGroupingType.none': 'None',
  'global.text.responseGroupingType.value': 'Value',
  'global.text.responseGroupingType.displayText': 'Display Text',

  // User Role translations
  'global.role.RoleAdmin': 'Administrator',
  'global.role.RoleSuperAdmin': 'Super Administrator',
  'global.role.RoleSupport': 'Support',
  'global.role.RoleUser': 'User',
  'global.role.RoleCollaborator': 'Collaborator',
  'global.role.RoleAuditor': 'Auditor',
  'global.role.RoleUserManager': 'User Manager',
  'global.role.RolePartner': 'Partner',

  'global.profile.photo.upload.success': 'Profile photo updated successfully',
  'global.profile.photo.upload.error': 'Error updating profile photo',

  // Global bulk delete translations - can be reused by any module
  'global.bulk.delete.success':
    '{successCount} {successElement} {eliminated} of {total} {totalElement}. {errorCount} {errorElement} could not be deleted.',
  'global.bulk.delete.error.only': '{errorCount} {errorElement} could not be deleted.',
  'global.bulk.delete.errors.title': 'Delete Errors',
  'global.errors.title': 'Errors',
  'global.import.errors.title': 'Import Errors',
  'global.bulk.delete.eliminated.singular': 'was deleted',
  'global.bulk.delete.eliminated.plural': 'were deleted',
  'global.bulk.delete.element.singular': 'element',
  'global.bulk.delete.element.plural': 'elements',
  'global.bulk.delete.could.not.be.deleted.singular': 'could not be deleted',
  'global.bulk.delete.could.not.be.deleted.plural': 'could not be deleted',

  // Generic image messages for reusable components
  'global.image.upload.title': 'Upload image',
  'global.image.change.title': 'Change image',
  'global.image.upload.no.file': 'Please select an image first',
  'global.image.upload.error': 'Error processing image',
  'global.image.upload.invalid.type': 'You can only upload image files',
  'global.image.upload.invalid.size': 'Image must be smaller than 5MB',
  'global.image.upload.formats': 'PNG, JPG, GIF up to 5MB',
  'global.image.rotate.left': 'Rotate left',
  'global.image.rotate.right': 'Rotate right',
  'global.image.drag.instruction': 'Drag the image to adjust the preview',
  'global.image.select.different': 'Select different image',

  // Date formats
  'global.date.format': 'MM/DD/YYYY',

  // HTTP Response Status Codes
  'global.httpResponseStatusCode.100': 'Continue',
  'global.httpResponseStatusCode.101': 'Switching Protocols',
  'global.httpResponseStatusCode.200': 'OK',
  'global.httpResponseStatusCode.201': 'Created',
  'global.httpResponseStatusCode.202': 'Accepted',
  'global.httpResponseStatusCode.203': 'Non-Authoritative Information',
  'global.httpResponseStatusCode.204': 'No Content',
  'global.httpResponseStatusCode.205': 'Reset Content',
  'global.httpResponseStatusCode.206': 'Partial Content',
  'global.httpResponseStatusCode.300': 'Multiple Choices',
  'global.httpResponseStatusCode.301': 'Moved Permanently',
  'global.httpResponseStatusCode.302': 'Found',
  'global.httpResponseStatusCode.303': 'See Other',
  'global.httpResponseStatusCode.304': 'Not Modified',
  'global.httpResponseStatusCode.305': 'Use Proxy',
  'global.httpResponseStatusCode.306': 'Unused',
  'global.httpResponseStatusCode.307': 'Temporary Redirect',
  'global.httpResponseStatusCode.400': 'Bad Request',
  'global.httpResponseStatusCode.401': 'Unauthorized',
  'global.httpResponseStatusCode.402': 'Payment Required',
  'global.httpResponseStatusCode.403': 'Forbidden',
  'global.httpResponseStatusCode.404': 'Not Found',
  'global.httpResponseStatusCode.405': 'Method Not Allowed',
  'global.httpResponseStatusCode.406': 'Not Acceptable',
  'global.httpResponseStatusCode.407': 'Proxy Authentication Required',
  'global.httpResponseStatusCode.408': 'Request Timeout',
  'global.httpResponseStatusCode.409': 'Conflict',
  'global.httpResponseStatusCode.410': 'Gone',
  'global.httpResponseStatusCode.411': 'Length Required',
  'global.httpResponseStatusCode.412': 'Precondition Failed',
  'global.httpResponseStatusCode.413': 'Request Entity Too Large',
  'global.httpResponseStatusCode.414': 'Request-URI Too Long',
  'global.httpResponseStatusCode.415': 'Unsupported Media Type',
  'global.httpResponseStatusCode.416': 'Requested Range Not Satisfiable',
  'global.httpResponseStatusCode.417': 'Expectation Failed',
  'global.httpResponseStatusCode.426': 'Upgrade Required',
  'global.httpResponseStatusCode.500': 'Internal Server Error',
  'global.httpResponseStatusCode.501': 'Not Implemented',
  'global.httpResponseStatusCode.502': 'Bad Gateway',
  'global.httpResponseStatusCode.503': 'Service Unavailable',
  'global.httpResponseStatusCode.504': 'Gateway Timeout',
  'global.httpResponseStatusCode.505': 'HTTP Version Not Supported',

  // RunCode Operation Status
  'global.runCodeOperationStatus.1': 'Pending',
  'global.runCodeOperationStatus.2': 'Installing',
  'global.runCodeOperationStatus.3': 'Running',
  'global.runCodeOperationStatus.4': 'Completed',
  'global.runCodeOperationStatus.5': 'Failed',
  'global.runCodeOperationStatus.6': 'Expired',
  'global.runCodeOperationStatus.7': 'Error',
  'global.runCodeOperationStatus.8': 'Not Found',

  // Process Config
  'process.config.version': 'Version',
  'process.config.versionSelectorDisabled': 'Version selector coming soon',

  'global.text.column.extraSmall': 'Extra Small',
  'global.text.column.small': 'Small',
  'global.text.column.medium': 'Medium',
  'global.text.column.large': 'Large',

  'global.dynamicEntityVersionOperation.1': 'Generate Token ReadOnly',
  'global.dynamicEntityVersionOperation.2': 'Generate Token Write',
  'global.dynamicEntityVersionOperation.3': 'Append Component',
  'global.dynamicEntityVersionOperation.4': 'Modify Component',
  'global.dynamicEntityVersionOperation.5': 'Remove Component',
  'global.dynamicEntityVersionOperation.6': 'Publish',
  'global.dynamicEntityVersionOperation.7': 'New Version Created',

  'global.userDisplayValue.full-name': 'Full Name',
  'global.userDisplayValue.email': 'Email',
  'global.userDisplayValue.extra-field': 'Extra Field',
  'global.userDisplayValue.position': 'Position',
  'global.userDisplayValue.area': 'Area',

  'global.internalTaskStatus.type1': 'Pending',
  'global.internalTaskStatus.type2': 'Processing',
  'global.internalTaskStatus.type3': 'Processed',
  'global.internalTaskStatus.type4': 'Error',
  'global.internalTaskStatus.type5': 'Skipped',
  'global.internalTaskStatus.type6': 'Cancelled',
  'global.internalTaskStatus.type7': 'Failed',

  // Clipbord
  'global.clipboard.copied': 'Copied to clipboard',
  'global.clipboard.error': 'Clipboard copy error',

  'actions.type.default': 'Process action',
  'actions.type.defaultInitial': 'Default Initial',
  'actions.type.completeInformation': 'Complete Information',
  'actions.type.approval': 'Approval',
  'actions.type.autoApprove': 'Automatic Approval',
  'actions.type.conditional': 'Conditional',
  'actions.type.executeTask': 'Execute Task',
  'actions.type.executeApiCall': 'Execute API Call',
  'actions.type.autoReject': 'Automatic Rejection',
  'actions.type.digitalSignature': 'Digital Signature',
  'actions.type.sendEmail': 'Send Email',
  'actions.type.executeQuery': 'Execute Database Query',
  'actions.type.dynamicEntityOperation': 'Operation on Dynamic Entity',
  'actions.type.generateExcel': 'Generate Excel',
  'actions.type.startProcessInstance': 'Start Process',
  'actions.type.setVariableData': 'Set Variable',
  'actions.type.setFormData': 'Set Form Data',
  'actions.type.parallel': 'Parallel',
  'actions.type.generateDocuments': 'Generate Documents',
  'actions.type.scheduledExecution': 'Scheduled Execution',
  'actions.type.sharePointOperation': 'SharePoint Operation',
  'actions.type.iterate': 'Iterate / Apply to Each',
  'actions.type.switch': 'Switch',
  'actions.type.internalOperation': 'Internal Operation',
  'actions.type.generatePlainTextFile': 'Generate Text File',
  'actions.type.importPlainTextFile': 'Import Plain Text File',
  'actions.type.consumeSequence': 'Consume Sequence',
  'actions.type.executeRpaFlow': 'Execute RPA Flow',
  'actions.type.integration': 'Integration',
  'actions.type.autoCancel': 'Automatic Cancel',
  'actions.type.autoVoid': 'Automatic Annulment',
  'actions.type.openAi': 'Open AI',
  'actions.type.executeProcessAction': 'Execute Process Action',
  'actions.type.googleIntegration': 'Google Integration',
  'actions.type.revertCancellation': 'Revert Cancellation',
  'actions.type.revertVoiding': 'Revert Voiding',
  'actions.type.ftpOperation': 'FTP Operation',
  'actions.type.runCode': 'Run Code',
  'actions.type.automyAi': 'Automy AI',
  'actions.type.whatsAppBusinessIntegration': 'WhatsApp Business Integration',
  'actions.type.microsoftTeamsIntegration': 'Microsoft Teams Integration',

  'accessPolicy.effect.allow': 'Allow',
  'accessPolicy.effect.deny': 'Deny',

  'global.text.number': 'Number',
  'global.text.operationType': 'Operation Type',
  'global.text.observations': 'Observations',
  'global.text.processingDate': 'Processing Date',
  'global.text.processedDate': 'Processed Date',
  'global.text.processingAttempts': 'Processing Attempts',
  'global.text.scheduledDate': 'Scheduled Date',
  'global.text.taskParameters': 'Task parameters',
  'global.text.alertEmails': 'Alert emails',
  'global.text.lastProcessingHeartbeat': 'Last processing heartbeat',
  'global.text.processingNodeId': 'Processing node ID',
  'global.text.processingNodeName': 'Processing node name',
  'global.text.dependsOnTaskNumber': 'Depends-on task',

  'internalTaskStatus.pending': 'Pending',
  'internalTaskStatus.processing': 'Processing',
  'internalTaskStatus.processed': 'Processed',
  'internalTaskStatus.error': 'Error',
  'internalTaskStatus.skipped': 'Skipped',
  'internalTaskStatus.cancelled': 'Cancelled',
  'internalTaskStatus.failed': 'Failed',
  'internalTaskStatus.unknown': 'Unknown',
};
